import { render, staticRenderFns } from "./ThreeCol333333.vue?vue&type=template&id=820511fe&"
import script from "./ThreeCol333333.vue?vue&type=script&lang=js&"
export * from "./ThreeCol333333.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports